import type { Customer } from "types/customer"

/**
 * hide-work-packages customer feature (config.customer_feature): hides every
 * Work Packages surface — Assignments nav item, batch-bar "Add to Package",
 * detail-view package buttons, draft tray, Drafts tab — for customers who
 * dispatch work through an asset-management system (Confirm etc.) instead.
 * Deep links (/work-items/:id) and external /work/:token pages keep working
 * so already-sent packages and legacy assignments remain reachable.
 */
// Dev-only preview of the hidden state without a DB row: load the app with
// ?hideWorkPackages=1. Captured once per page load (like the ?customerId
// dev pin) so it sticks across SPA navigations within the tab.
const devForceHidden =
    import.meta.env.DEV &&
    typeof window !== "undefined" &&
    new URLSearchParams(window.location.search).get("hideWorkPackages") === "1"

export function isWorkPackagesHidden(customerData: Customer | undefined): boolean {
    if (devForceHidden) {
        return true
    }
    return customerData?.customerFeatures?.includes("hide-work-packages") ?? false
}
